// extracted by mini-css-extract-plugin
export default {"formInput":"YourTotalIncome_formInput__Rxyzl","inputs":"YourTotalIncome_inputs__XP7y9"};